import React, { useState } from 'react';
import { motion } from 'framer-motion';
import './FruitMachine.css';

const fruits = ['🍒', '🍋', '🍊', '🍉', '🍇'];
const totalRepeats = 3; // Number of times to repeat the sequence of fruits
const scores = { '🍒': 250, '🍋': 150, '🍊': 200, '🍉': 300, '🍇': 350 };

const FruitMachine = () => {
  const [reels, setReels] = useState([Array(totalRepeats).fill(fruits).flat(), Array(totalRepeats).fill(fruits).flat(), Array(totalRepeats).fill(fruits).flat()]);
  const [spin, setSpin] = useState([0, 0, 0]);
  const [score, setScore] = useState(0);
  const [completedSpins, setCompletedSpins] = useState(0);
  const [lastScoreIncrement, setLastScoreIncrement] = useState(0);
  const [showScoreAnimation, setShowScoreAnimation] = useState(false);

  const spinReels = () => {
    setSpin(prevSpin => {
      const newSpin = prevSpin.map((oldSpin, i) => {
        let newSpinValue = Math.floor(Math.random() * fruits.length) * -200 * totalRepeats;
        if (newSpinValue === oldSpin) {
          checkWin(i);
        }
        return newSpinValue;
      });
  
      // Check if all the new spin values are the same as the old ones
      if (newSpin.every((value, i) => value === prevSpin[i])) {
        // If they are, spin the reels again
        spinReels();
      }
  
      return newSpin;
    });
    setCompletedSpins(0); // Reset the counter when a new spin starts
  };
  
  const playAgain = () => {
    setScore(250); // Reset the score
    setReels([Array(totalRepeats).fill(fruits).flat(), Array(totalRepeats).fill(fruits).flat(), Array(totalRepeats).fill(fruits).flat()]); // Reset the reels
    setSpin([0, 0, 0]); // Reset the spin
    
  };
  
  

  const checkWin = (reelIndex) => {
    setCompletedSpins(prevSpins => {
      const newSpins = prevSpins + 1;
      if (newSpins === 3) { // Check the result only after all reels have come to rest
        const results = spin.map(spinValue => fruits[Math.round(-spinValue / (200 * totalRepeats))]);
        if (results[0] === results[1] && results[1] === results[2]) {
          const scoreIncrement = scores[results[0]];
          setScore(prevScore => prevScore + scoreIncrement);
          setLastScoreIncrement(scoreIncrement); // Set the last score increment
          setShowScoreAnimation(true); // Show the score animation
        } else {
          setScore(prevScore => prevScore - 10); 
        }
        
      }
      return newSpins;
    });
  };

  return (
    <div className="fruit-machine">
              {showScoreAnimation && (
  <motion.div
    initial={{ opacity: 1, scale: 1 }}
    animate={{ opacity: 0, scale: 2 }}
    transition={{ duration: 1 }}
    onAnimationComplete={() => setShowScoreAnimation(false)}
    className="score-animation"
  >
    {lastScoreIncrement}
  </motion.div>
)}
      {score > -5 ? (
        <div>
        <p className="score">{score}</p>
        <div className="reels">
          {reels.map((reel, i) => (
            <div key={i} className="reel">
              <motion.div
                style={{ y: spin[i] }}
                animate={{ y: spin[i] }}
                transition={{ duration: 1, ease: "linear", onComplete: () => checkWin(i) }}
              >
                {reel.map((fruit, index) => (
                  <div key={index} className="fruit">
                    {fruit}
                  </div>
                ))}
              </motion.div>
            </div>
          ))}
        </div>
       

        <button onClick={spinReels}>Spin</button>

        </div>
      ) : (
        <div>
          <p>Game Over</p>
          <button onClick={playAgain}>Play Again</button>
        </div>
      )}
      
    </div>
  );
  

  
};

export default FruitMachine;
